import { toast } from "react-toastify";

export const agregarCarrito = ( producto ) => {

    const { nombre, imagen, stock, precio, idproducto } = producto;

    if ( parseInt(stock) === 0 ) {
        // throw new Error(`No hay stock suficiente para el producto ${ producto.Nombre }`);
        toast.warn("No hay suficiente stock para el producto", {
                        autoClose: 3000,
                        position: "top-right",
                    });
                    return;
    }

    const objProductCarrito = {
        idprod: idproducto,
        nombrep: nombre,
        cantidad: 1,
        imagen: imagen,
        precio: precio,
    };
    let carrito = JSON.parse(localStorage.getItem("CarritoJucumari")) ?? [];

    const existProduct = carrito.some(
        (carritoState) => carritoState.idprod === objProductCarrito.idprod
    );

    if (existProduct) {
        carrito = carrito.map((carritoState) =>
            carritoState.idprod === objProductCarrito.idprod
                ? {
                      ...carritoState,
                      cantidad:
                          carritoState.cantidad + objProductCarrito.cantidad,
                  }
                : carritoState
        );
    } else {
        carrito.push(objProductCarrito);
    }

    localStorage.setItem("CarritoJucumari", JSON.stringify(carrito));
    window.dispatchEvent(new Event("storage"));
       toast.success("Producto agregado a su carrito", {
                autoClose: 3000,
                position: "top-right",
            });
}
